import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.SpacePets;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "SpacePets.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "SpacePets.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "SpacePets.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/SpacePets/scenes/IntroductionScene.ts